/* eslint-disable camelcase */
import api, { rawClient } from '../api';
import { NoIdGuaranteePolicyResponse } from '../../models/Insurance/Guarantee';
import { PsGuaranteeWithResultSnapshot } from '../../models/Insurance/Guarantee/Purchase/GuestPaymentController';
import { GuaranteePaymentMethod } from '../../constants/insurance';
import {
    policyToSnapshot,
    RawGuaranteePolicyResponse,
} from '../insuranceGuarantee';
import { getBackVersion } from '../../config';

type GetTransmitArgs = {
    psInsuranceId: string;
    doc: string | null;
    accessCode: string | null;
    accessToken?: string;
};

type PostTransmitArgs = GetTransmitArgs & {
    methodType: GuaranteePaymentMethod;
    installmentCount: number;
    cardHolder: string;
    cardHolderDoc: string;
    cardNumber: string;
    cardPin: string;
    cardValidity: string;
};

type PolicyDownloadArgs = {
    psInsuranceId: string;
    accessToken?: string;
    accessCode: string | null;
    doc: string | null;
};

export type PsGuaranteeWithResultNoIdSnapshot = Omit<
    PsGuaranteeWithResultSnapshot,
    'policy'
> & {
    policy: NoIdGuaranteePolicyResponse | null;
};

type RawPsGuaranteeWithResultResponse = Omit<
    PsGuaranteeWithResultSnapshot,
    'policy'
> & {
    policy: RawGuaranteePolicyResponse;
};

const resultToSnapshot = (
    response: RawPsGuaranteeWithResultResponse
): PsGuaranteeWithResultNoIdSnapshot => ({
    ...response,
    policy: response.policy.psInsuranceId
        ? policyToSnapshot(response.policy)
        : null,
});

const getGuestGuarantee = ({
    psInsuranceId,
    doc,
    accessCode,
    accessToken,
}: GetTransmitArgs): Promise<PsGuaranteeWithResultNoIdSnapshot> =>
    api
        .request<RawPsGuaranteeWithResultResponse>({
            url: `${getBackVersion()}/insurances/guarantee/${psInsuranceId}`,
            method: 'GET',
            action: 'GUEST_LOGIN',
            params: {
                doc: doc,
                access_code: accessCode,
                access_token: accessToken,
            },
        })
        .then(resultToSnapshot);

const policyDownload = ({
    psInsuranceId,
    accessToken,
    accessCode,
    doc,
}: PolicyDownloadArgs): Promise<void> => {
    const query = accessToken
        ? `access_token=${accessToken}`
        : `doc=${doc}&accessCode=${accessCode}`;
    return rawClient.download({
        method: 'GET',
        url: `${getBackVersion()}/insurances/guarantee/${psInsuranceId}/policy_download?${query}`,
    });
};

export { getGuestGuarantee, policyDownload };
export type { GetTransmitArgs, PostTransmitArgs };
